import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kan jag träna på kunskapsprovet gratis?";
const SHORT_ANSWER = "Ja. Alkoholprovet ger 5 gratis frågor per dag, och det finns en separat gratis prov-sida utan registrering.";

export const Route = createFileRoute("/fraga/kan-jag-trana-gratis")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kan jag träna på kunskapsprovet gratis" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Gratisalternativet räcker för att förstå formatet och avgöra om du behöver fördjupa träningen. Med Premium (199 kr för 10 dagar / 349 kr för 30 dagar) får du obegränsat antal frågor, statistik och provsimulering."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/gratis-ovningsfragor-serveringstillstand", label: "Gratis övningsfrågor – 5 riktiga frågor" }}
      related={[{"to": "/fraga/vad-betyder-pbi", "label": "Vad betyder PBI?"}, {"to": "/fraga/vilka-rakas-till-pbi-kretsen", "label": "Vilka räknas till PBI-kretsen?"}, {"to": "/fraga/hur-pluggar-jag-effektivt", "label": "Hur pluggar jag effektivt inför kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kan jag träna på kunskapsprovet gratis?" },
      { name: "description", content: "Ja. Alkoholprovet ger 5 gratis frågor per dag, och det finns en separat gratis prov-sida utan registrering." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/kan-jag-trana-gratis" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/kan-jag-trana-gratis" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/kan-jag-trana-gratis",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kan jag träna på kunskapsprovet gratis", url: "https://alkoholprovet.se/fraga/kan-jag-trana-gratis" },
      ]),
    ],
  }),
});
